import React, { useState } from 'react';
import { AspectRatioWrapper, ResponsiveImage } from '../../../../../components';
import classNames from 'classnames';

import {
  PrevArrow as ArrowLeft,
  NextArrow as ArrowRight,
} from '../../../../../components/Slider/Arrows';
import css from './ImageSlider.module.css';

const ImageSlider = props => {
  const { rootClassName, className, images, title } = props;

  const [index, setIndex] = useState(0);
  const total = images.length;

  const prev = e => {
    e.preventDefault();
    e.stopPropagation();
    setIndex((index - 1 + total) % total);
  };
  const next = e => {
    e.preventDefault();
    e.stopPropagation();
    setIndex((index + 1) % total);
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <AspectRatioWrapper width={4} height={3} className={classes}>
      <div className={css.sliderWrapper}>
        <div className={css.sliderTrack} style={{ transform: `translateX(-${index * 100}%)` }}>
          {images.map((img, i) => {
            const url = img?.attributes?.variants?.default?.url;
            return (
              <div key={i} className={css.slide}>
                <div className={css.imageBackground} style={{ backgroundImage: `url(${url})` }} />
                <ResponsiveImage
                  rootClassName={css.imageForeground}
                  alt={title}
                  image={img}
                  variants={['default']}
                />
              </div>
            );
          })}
        </div>

        {total > 1 && (
          <div className={css.navButtons}>
            <ArrowLeft
              onClick={prev}
              className={classNames(css.navButton, { [css.disabled]: index === 0 })}
            />
            <ArrowRight
              onClick={next}
              className={classNames(css.navButton, { [css.disabled]: index === total - 1 })}
            />
          </div>
        )}
        {total > 1 && (
          <div className={css.dotsWrapper}>
            {images.map((_, i) => (
              <span
                key={i}
                className={classNames(css.dot, { [css.activeDot]: i === index })}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIndex(i);
                }}
              />
            ))}
          </div>
        )}
      </div>
    </AspectRatioWrapper>
  );
};

export default ImageSlider;
